import React from "react";
import { SortableContainer as RSHContainer } from "react-sortable-hoc";
import classes from "./SortableContainer.module.scss";

export const SortableContainer = RSHContainer(({ children }) => {
  return <div className={classes.root}>{children}</div>;
});
